/**
 * EO task 2 with the live virtual examiner (P3B-06), shared by the web and the mobile app: when a
 * turn of speech of the learner is over. The turn ends after a pause following speech, or after
 * a long silence without speech (the examiner then relaunches). The server keeps the time.
 */

/** Pause after speech that ends a turn. */
export const EXAMINER_END_OF_TURN_MS = 2500;
/** Silence without any speech after which the turn is sent anyway (the examiner relaunches). */
export const EXAMINER_RELAUNCH_MS = 8000;

export interface TurnListening {
  /** The learner has spoken during this turn. */
  spoke: boolean;
  /** Last moment a voice was heard (ms). */
  lastVoice: number;
  /** Start of the turn (ms). */
  startedAt: number;
}

export function startTurn(now: number): TurnListening {
  return { spoke: false, lastVoice: now, startedAt: now };
}

/** Next listening state for a new sound level reading; `end` is true when the turn is over. */
export function listenTurn(state: TurnListening, voice: boolean, now: number): TurnListening & { end: boolean } {
  if (voice) return { ...state, spoke: true, lastVoice: now, end: false };
  const end = state.spoke ? now - state.lastVoice >= EXAMINER_END_OF_TURN_MS : now - state.startedAt >= EXAMINER_RELAUNCH_MS;
  return { ...state, end };
}

/** Level threshold in decibels (mobile metering, from -160 to 0) above which a voice is heard. */
export const EXAMINER_VOICE_DB = -40;
